<script>
    // const url= 'http://192.168.30.208:80'
    const url= 'http://120.55.60.153'
    export default {
        url,
    }
</script>



// WEBPACK FOOTER //
// src/config/common.vue